/*
  AZOURANE OSEA-structured storefront interactions (AZO-413).
  - phone drawer and search disclosures: scrim / Escape close, focus into the search field,
    focus kept inside the open drawer
  - product rows on phone: text controls Prethodni / Sljedeći scroll the snap row
  - product gallery: thumbnails and Prethodna / Sljedeća switch the main image
  - quantity stepper on the product page
  - phone sticky buy bar: shown whenever the main add button is outside the visible
    screen, both before the visitor reaches it and after she scrolls past it
  Nothing here adds to cart: every add form is intercepted by snippets/az-mini-cart.liquid.
*/
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';

  function closeAll(except) {
    document.querySelectorAll('details[data-az-os-drawer][open], details[data-az-os-search][open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-az-os-drawer-close]');
    if (closer) {
      var drawer = closer.closest('details[data-az-os-drawer]');
      if (drawer) {
        drawer.removeAttribute('open');
        var summary = drawer.querySelector('summary');
        if (summary) summary.focus();
      }
      return;
    }
    var search = document.querySelector('details[data-az-os-search][open]');
    if (search && !search.contains(e.target)) search.removeAttribute('open');
  });

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('details[data-az-os-drawer][open], details[data-az-os-search][open]');
      if (!open) return;
      open.removeAttribute('open');
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
      return;
    }
    if (e.key !== 'Tab') return;
    var drawer = document.querySelector('details[data-az-os-drawer][open]');
    if (!drawer) return;
    var panel = drawer.querySelector('.az-os-drawer__panel');
    if (!panel) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), visible);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (!panel.contains(active)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  document.querySelectorAll('details[data-az-os-search]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        closeAll(d);
        var input = d.querySelector('[data-az-os-search-input]');
        if (input) setTimeout(function () { input.focus(); }, 30);
      }
    });
  });
  document.querySelectorAll('details[data-az-os-drawer]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('az-os-drawer-open', d.open);
      if (d.open) {
        closeAll(d);
        var first = d.querySelector('.az-os-drawer__panel a, .az-os-drawer__panel button');
        if (first) setTimeout(function () { first.focus(); }, 30);
      }
    });
  });

  // product rows: text controls on phone
  document.querySelectorAll('[data-az-os-row]').forEach(function (row) {
    var section = row.closest('section') || document;
    var controls = section.querySelector('[data-az-os-row-controls]');
    if (!controls) return;
    var prev = controls.querySelector('[data-az-os-prev]');
    var next = controls.querySelector('[data-az-os-next]');
    var items = Array.prototype.slice.call(row.children);
    if (items.length < 2) { controls.hidden = true; return; }
    function nearest() {
      var rowRect = row.getBoundingClientRect();
      var centre = rowRect.left + rowRect.width / 2;
      var best = 0, bestDist = Infinity;
      items.forEach(function (li, i) {
        var r = li.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - centre);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function go(i) {
      if (i < 0 || i >= items.length) return;
      var li = items[i];
      var left = li.offsetLeft - (row.clientWidth - li.clientWidth) / 2;
      if (row.scrollTo) row.scrollTo({ left: left, behavior: behavior }); else row.scrollLeft = left;
      sync(i);
    }
    function sync(i) {
      if (i === undefined) i = nearest();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= items.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(nearest() - 1); });
    if (next) next.addEventListener('click', function () { go(nearest() + 1); });
    var ticking = false;
    row.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });
    sync(0);
  });

  // product gallery
  document.querySelectorAll('[data-az-os-gallery]').forEach(function (g) {
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-az-os-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-az-os-thumb]'));
    var prev = g.querySelector('[data-az-os-gallery-prev]');
    var next = g.querySelector('[data-az-os-gallery-next]');
    if (slides.length < 2) { var nav = g.querySelector('.az-os-gallery__nav'); if (nav) nav.hidden = true; return; }
    var current = 0;
    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { if (k === current) s.removeAttribute('hidden'); else s.setAttribute('hidden', ''); });
      thumbs.forEach(function (t, k) { if (k === current) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      var t = thumbs[current];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: behavior });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    // CRO 2026-09-17: on phones the Prethodna / Sljedeća controls are hidden, so the small
    // thumbnails were the only way to see another photo. A sideways swipe on the main image
    // now moves to the next or previous photo. Vertical scrolling is left alone.
    var main = g.querySelector('.az-os-gallery__main');
    if (main) {
      var startX = 0, startY = 0, tracking = false;
      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        show(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
      main.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    }
    show(0);
  });

  // quantity stepper
  document.querySelectorAll('[data-az-os-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    var minus = box.querySelector('[data-az-os-qty-minus]');
    var plus = box.querySelector('[data-az-os-qty-plus]');
    if (!input) return;
    function set(v) {
      v = parseInt(v, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 99) v = 99;
      input.value = v;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
  });

  // Own the viewport, not a product-section containing block. iOS browser chrome
  // changes the visible viewport while scrolling; measure that viewport each frame.
  var mainButton = document.querySelector('[data-az-os-main-add]');
  var sticky = document.querySelector('[data-az-os-sticky]');
  if (mainButton && sticky) {
    document.body.appendChild(sticky);
    var phone = window.matchMedia('(max-width: 749px)');
    var viewport = window.visualViewport;
    var pendingFrame = 0;
    function placeSticky() {
      pendingFrame = 0;
      var active = document.activeElement;
      var editing = active && active.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]');
      // CRO 2026-09-17: in the Facebook and Instagram in-app browsers the first screen ends
      // above the price, so a visitor who never scrolled saw no price and no way to buy.
      // The bar now shows while the main button is below the screen as well as above it.
      var rect = mainButton.getBoundingClientRect();
      var visibleBottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      var outside = rect.bottom <= 0 || rect.top >= visibleBottom;
      var show = phone.matches && outside && !editing && (!viewport || viewport.scale <= 1.05);
      document.body.classList.toggle('az-os-sticky-on', show);
      if (!show) { document.body.style.removeProperty('--az-sticky-clearance'); return; }
      var height = sticky.getBoundingClientRect().height;
      var bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      sticky.style.top = Math.max(0, bottom - height) + 'px';
      document.body.style.setProperty('--az-sticky-clearance', height + 16 + 'px');
    }
    function scheduleSticky() { if (!pendingFrame) pendingFrame = requestAnimationFrame(placeSticky); }
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    window.addEventListener('pageshow', scheduleSticky);
    document.addEventListener('focusin', scheduleSticky);
    document.addEventListener('focusout', scheduleSticky);
    if (viewport) {
      viewport.addEventListener('resize', scheduleSticky, { passive: true });
      viewport.addEventListener('scroll', scheduleSticky, { passive: true });
    }
    if ('ResizeObserver' in window) new ResizeObserver(scheduleSticky).observe(sticky);
    var stickyForm = sticky.querySelector('form');
    var mainForm = mainButton.closest('form');
    if (stickyForm && mainForm) {
      var q = mainForm.querySelector('input[name="quantity"]');
      var sq = stickyForm.querySelector('input[name="quantity"]');
      function syncQuantity() { if (q && sq) sq.value = q.value; }
      if (q && sq) {
        q.addEventListener('input', syncQuantity);
        q.addEventListener('change', syncQuantity);
        syncQuantity();
      }
    }
    scheduleSticky();
  }

})();

// Local preview never transmits signup data. Shopify handles consent and signup on the published theme.
(function(){
  var d=document.getElementById('az-welcome-dialog'); if(!d)return;
  var opener;
  document.querySelectorAll('[data-az-welcome-open]').forEach(function(b){b.addEventListener('click',function(){opener=b;d.showModal();});});
  d.querySelector('[data-az-welcome-close]').addEventListener('click',function(){d.close();});
  d.addEventListener('close',function(){if(opener)opener.focus();});
  if(location.hostname==='127.0.0.1'||location.hostname==='localhost'){d.querySelector('form').addEventListener('submit',function(e){e.preventDefault();});}
  if(d.querySelector('[data-az-welcome-result]'))d.showModal();
})();

(function () {
  document.querySelectorAll('[data-az-argan-theatre]').forEach(function (stage) {
    var list = stage.querySelector('[data-az-argan-tabs]');
    var tabs = Array.from(stage.querySelectorAll('[data-az-argan-choice]'));
    var panels = Array.from(stage.querySelectorAll('[data-az-argan-panel]'));
    if (!list || tabs.length !== panels.length || !tabs.length) return;
    list.setAttribute('role', 'tablist');
    list.setAttribute('aria-label', stage.querySelector('h2').textContent);
    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].tabIndex = 0;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus({ preventScroll: true });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (event) {
        var next = i;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(next, true);
      });
    });
    select(0, false);
    stage.classList.add('az-argan-ready');
  });
})();
